/**
 * PWA Service Worker registration.
 *
 * - Só registra em produção OU se REACT_APP_PWA_DEV=1 no build (útil para
 *   testar localmente sem ter que rodar `yarn build`).
 * - Confere por updates a cada 60s — quando há um SW novo aguardando, manda
 *   SKIP_WAITING e recarrega quando o controller mudar.
 * - Tolera ambiente sem navigator/serviceWorker (SSR, browsers antigos).
 */

const SW_PATH = '/sw.js';
const ENABLED = process.env.NODE_ENV === 'production' || process.env.REACT_APP_PWA_DEV === '1';

export function registerServiceWorker() {
  if (!ENABLED) return;
  if (typeof window === 'undefined') return;
  if (!('serviceWorker' in navigator)) return;

  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register(SW_PATH)
      .then((registration) => {
        // Verifica updates periodicamente (sem flood)
        setInterval(() => {
          registration.update().catch(() => {});
        }, 60 * 1000);

        // Quando há um SW novo aguardando, faz takeover imediato
        registration.addEventListener('updatefound', () => {
          const newWorker = registration.installing;
          if (!newWorker) return;
          newWorker.addEventListener('statechange', () => {
            if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
              // Há uma versão antiga ativa — força a nova a tomar o controle
              newWorker.postMessage('SKIP_WAITING');
            }
          });
        });

        let refreshing = false;
        navigator.serviceWorker.addEventListener('controllerchange', () => {
          if (refreshing) return;
          refreshing = true;
          window.location.reload();
        });
      })
      .catch((err) => {
        // Não bloqueia a app — apenas loga em dev.
        if (process.env.NODE_ENV !== 'production') {
          // eslint-disable-next-line no-console
          console.warn('[PWA] SW registration failed:', err);
        }
      });
  });
}

export function unregisterServiceWorker() {
  if (typeof window === 'undefined' || !('serviceWorker' in navigator)) return;
  navigator.serviceWorker.getRegistrations().then((regs) => {
    regs.forEach((reg) => reg.unregister());
  });
}
